import ReusableModal from '@components/Modal/ReusableModal.component';
import QuestionSelectorCard from '@components/QuestionSelectorCard/QuestionSelectorCard';
import styled from '@emotion/styled';
import { AddOutlined, CheckCircle, DeleteOutlineOutlined, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Button, Divider, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { createFileRoute, useLocation } from '@tanstack/react-router'
import { useState } from 'react';

export const Route = createFileRoute('/(partner)/_partner/question-selector')({
  component: RouteComponent,
})

const CustomButtonStyle = styled(IconButton)({
    border: '1px solid var(--Interviewer-Near-White)',
    borderRadius: '8px',
    width: '40px',
    height: '40px'
})

const CustomQuestionBox = styled(Box)({
    width: '100%',
    border: '1px solid var(--Light-Gray)',
    backgroundColor: '#fff',
    padding: '24px',
    boxShadow: '0px 1px 2px 0px #0205111A',
    borderRadius: '12px'
})

function RouteComponent() {

    // Novo
    const location = useLocation().state
    const [questions, setQuestions] = useState(location.questions.data)
    const [expandedCategory, setExpandedCategory] = useState(false)

    const [expandedMap, setExpandedMap] = useState({});

    const toggleExpand = (id) => {
      setExpandedMap((prev) => ({
        ...prev,
        [id]: !prev[id],
      }));
    };



    const [isExpanded, setIsExpanded] = useState(false);
    // Modal UI state (style-only, no business logic)
    const [openModal, setOpenModal] = useState(false);
    const [questionText, setQuestionText] = useState('');
    const [questionStructure, setQuestionStructure] = useState<number>(2); // 1: Text, 2: One answer, 3: Multiple
    const [answers, setAnswers] = useState<{ answer: string; correct: boolean }[]>([
    { answer: '', correct: true },
    { answer: '', correct: false },
    ]);

    const handleStructureChange = (value: number) => {
    setQuestionStructure(value);
    if (value === 2) {
        setAnswers(answers.map((a, i) => ({ ...a, correct: i === 0 })));
    }
    };

    const handleAnswerChange = (index: number, field: 'answer' | 'correct', value: string | boolean) => {
    const newAnswers = [...answers];
    newAnswers[index] = { ...newAnswers[index], [field]: value };
    setAnswers(newAnswers);
    };

    const handleAddAnswer = () => setAnswers(prev => [...prev, { answer: '', correct: false }]);
    const handleRemoveAnswer = (index: number) => {
    if (answers.length > 2) setAnswers(answers.filter((_, i) => i !== index));
    };



      //Novo
    const { state } = useLocation();

    console.log('hhhhhhej', state);



  return <>
    
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' ,maxWidth: '80%', mx: 'auto'}}>
      <Box sx={{display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'center', pb: '32px'}}>
          <Typography variant='h1'>Customize your interview</Typography>
          <Typography>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</Typography>
      </Box>

      <Box sx={{display: 'flex', flexDirection: 'column', gap: '20px' ,width: '100%'}}>
        {questions && questions.map((question) => (
          <Box key={question.id} sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography variant='h2'>{question.name}</Typography>
              <IconButton
                onClick={() => toggleExpand(question.id)}
                sx={{ padding: '8px', width: '40px', height: '40px', borderRadius: '0px' }}
              >
                {expandedMap[question.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
              </IconButton>
            </Box>
            <Divider sx={{ mt: 1, mb: 1 }} />

            {/* Ovde prikazujemo pitanja unutar kategorije */}
            {expandedMap[question.id] && question.questions?.length > 0 && (
              <Box sx={{ pl: 4, mt: 1 }}>
                {question.questions.map((q) => (
                  <Box key={q.id} sx={{ mb: 1, p: 1, border: '1px solid #eee', borderRadius: 1 }}>
                    <Typography>{q.name}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        ))}
      </Box>    

      {/* Category  */}
      {/* <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mt: '32px', mb: '16px'}}>
        {state.categories?.map((category) => (
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Typography variant='h2'>{category?.name}</Typography>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '16px'}}>
                        <Box sx={{
                            backgroundColor: 'var(--Light-Gray)',
                            px: '14px',
                            py: '6px',
                            borderRadius: '8px'
                        }}>
                        <Typography sx={{color: 'var(--Interviewer-Green)', fontWeight: '600', fontSize: '14px'}}>{category?.totalNumberOfQuestions} Questions</Typography>
                        </Box>
                        <CustomButtonStyle>
                        <DeleteOutlineOutlined fontSize="small" color="primary" sx={{width: '18px', height: '18px'}} />
                        </CustomButtonStyle>
                        <IconButton onClick={() => setIsExpanded(e => !e)} sx={{padding: '8px', width: '40px', height: '40px', borderRadius: '0px'}}>
                        {isExpanded ? <KeyboardArrowUp fontSize="small" color="primary" sx={{width: '24px', height: '24px'}}/> : <KeyboardArrowDown fontSize="small" color="primary" sx={{width: '24px', height: '24px'}}/>}
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{mb: '16px', mt: '16px'}}/>
                <QuestionSelectorCard category={category}/>
            </Box>
        ) )}
      </Box> */}

      
      <Button variant='contained' sx={{mt: '24px', mr: 'auto'}} onClick={() => setOpenModal(true)}>Add a question</Button>
      {/* Style-only modal copied from create-category */}
      <ReusableModal open={openModal} onClose={() => setOpenModal(false)}>
        <Typography variant='h2' sx={{ pb: '37px' }}>Add a question</Typography>
        <Typography sx={{ fontWeight: 500, pb: '8px' }}>Question Text</Typography>
        <TextField
          multiline
          minRows={4}
          placeholder="Add a question text here"
          fullWidth
          value={questionText}
          onChange={(e) => setQuestionText(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: '1px solid var(--Interviewer-Lightest-Black)',
                borderRadius: '12px',
              },
              '&:hover fieldset': {
                borderColor: 'var(--Interviewer-Lightest-Black)',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'var(--Interviewer-Lightest-Black)',
              },
            },
          }}
        />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, pt:'37px', pb: '30px', color: 'var(--Interviewer-Black)' }}>
          <Typography sx={{ fontWeight: 500, color: 'var(--Interviewer-Black)' }}>Choose answer type</Typography>
          <RadioGroup
            value={questionStructure}
            onChange={(e) => handleStructureChange(Number(e.target.value))}
            row
          >
            <FormControlLabel 
              value={2} 
              control={<Radio />} 
              label="One answer" 
              sx={{ color: 'var(--Interviewer-Black)' }}
            />
            <FormControlLabel 
              value={3} 
              control={<Radio />} 
              label="Multiple Choice" 
              sx={{ color: 'var(--Interviewer-Black)' }}
            />
            <FormControlLabel 
              value={1} 
              control={<Radio />} 
              label="Textual" 
              sx={{ color: 'var(--Interviewer-Black)' }}
            />
          </RadioGroup>
        </Box>

        <Divider sx={{ mb: '30px', borderColor: 'var(--Interviewer-Near-White)' }} />

        {questionStructure === 1 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', pb: '24px' }}>
            <Box>
              <Typography sx={{ fontWeight: 500, fontSize: '16px', color: 'var(--Interviewer-Black)', mb: 1 }}>
                Answer
              </Typography>
              <TextField
                placeholder="Add answer text here"
                fullWidth
                variant="outlined"
                value={answers[0]?.answer || ''}
                onChange={e => handleAnswerChange(0, 'answer', e.target.value)}
                multiline
                minRows={4}
              />
            </Box>
          </Box>
        ) : (
          <>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: '24px', pb: '24px'}}>
              {answers.map((answer, index) => (
                <Box key={index}>
                  <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '8px'}}> 
                    <Typography sx={{ fontWeight: 500, fontSize: '16px', color: 'var(--Interviewer-Black)' }}>
                      Answer {index + 1}
                    </Typography>
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <CheckCircle 
                        fontSize="small" 
                        sx={{ 
                          color: answer.correct ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Lightest-Black)',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          if (questionStructure === 2) {
                            setAnswers(answers.map((a, i) => ({ ...a, correct: i === index })));
                          } else {
                            handleAnswerChange(index, 'correct', !answer.correct);
                          }
                        }}
                      />
                      <Typography sx={{ fontSize: 14, color: 'var(--Interviewer-Black)' }}>
                        Mark as correct
                      </Typography>
                      {answers.length > 2 && (
                        <Button 
                          size="small" 
                          onClick={() => handleRemoveAnswer(index)}
                          sx={{ ml: 1, minWidth: 'auto', p: 0.5 }}
                        >
                          Remove
                        </Button>
                      )}
                    </Box>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <TextField
                      placeholder={`Add answer ${index + 1} text here`}
                      fullWidth
                      variant="outlined"
                      value={answer.answer}
                      onChange={(e) => handleAnswerChange(index, 'answer', e.target.value)}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
            <Box sx={{ mb: '32px', p: '24px', border: '1px dashed var(--Interviewer-Near-White)', borderRadius: '12px', display: 'flex', alignItems: 'center', gap: '30px', cursor: 'pointer' }} onClick={handleAddAnswer}>
              <Box sx={{background: '#fff', boxShadow: '0px 0.75px 1.5px 0px #0205111A', p: '10px', borderRadius: '10px'}}>
                <AddOutlined color="primary" fontSize='small'/>
              </Box>
              <Typography>Add another choice</Typography>
            </Box>
          </>
        )}

        <Button 
          variant="contained" 
          fullWidth 
          onClick={() => setOpenModal(false)}
        >
          Add a question
        </Button>
      </ReusableModal>

    </Box>
  
  </>
}
